import {SETTINGS_SCOPE_SECTIONS} from "@/store/constants";
import {settingsModalAtom} from "@/store/jotaiAtoms";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/_agency/agency/$agencyId/subbrand/$companyId/edit")({
  params: {
    parse: raw => ({
      agencyId: +raw.agencyId,
      companyId: +raw.companyId,
    }),
    stringify: params => ({
      agencyId: params.agencyId?.toString(),
      companyId: params.companyId?.toString(),
    }),
  },
  validateSearch: zodValidator(
    z.object({
      section: z.enum(SETTINGS_SCOPE_SECTIONS).optional().catch(undefined),
    }),
  ),
  loaderDeps: ({search}) => ({section: search.section}),
  loader: ({deps, params}) => {
    getDefaultStore().set(settingsModalAtom, {
      scope: {id: params.companyId, type: "brand"},
      section: deps.section ?? "info",
    });

    throw redirect({
      to: "/agency/$agencyId/subbrand/$companyId",
      params: {agencyId: params.agencyId, companyId: params.companyId},
      replace: true,
      search: true,
    });
  },
});
